import { Col, Input, Label } from "reactstrap";
import { BasicRadioAndCheckboxBlog, SimpleCheckbox } from "../../../../Constant";
import { BASIC_RADIO_CHECKBOX_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";

export const SimpleCheckboxs = () => {
  return (
    <Col md="12">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{SimpleCheckbox}</H6>
        <div className="form-check-size">
          <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
            <Input id="inline-1" type="checkbox" />
            <Label htmlFor="inline-1" check>
              {BasicRadioAndCheckboxBlog}
            </Label>
          </div>
          {BASIC_RADIO_CHECKBOX_LIST.map(({ id, text, defaultChecked }, index) => (
            <div className="form-check form-check-inline checkbox checkbox-dark mb-0" key={index}>
              <Input id={id} type="checkbox" defaultChecked={defaultChecked} />
              <Label htmlFor={id} check>
                {text}
              </Label>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};
